export const ROUTES = {
  WELCOME_SCREEN: '/',
  PRODUCTS_SCREEN: '/products',
  STYLES_SCREEN: '/styles',
  BUILD_SCREEN: '/build',
  MATERIAL_SCREEN: '/materials',
  OPTIONS_SCREEN: '/options',
  QUOTE_SCREEN: '/quote',
};

export const HEADER_HEIGHT = 89;

export const APPSTATE_KEY = 'appState-storage';

export const UI = { EASE_QUINT: [0.86, 0, 0.07, 1] };
